import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchActivities } from './users.action';

@Injectable({ providedIn: 'root' })
export class ActivityTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '', 
                action: null, //Null for select list
                type: null, //Null for select list
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    recordId: string = "0";
    actions = [];
    types = [
        {"id": 1, "name": "ACTIVITY.user"},
        {"id": 2, "name": "ACTIVITY.system"},
    ];
    hasFilter = false;
    columns = [
                { prop: 'created_at', name: 'ACTIVITY.date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'action', name: 'ACTIVITY.action', sortable: false, hasFilter: true, filter: "select", options: 'actions', options_id: "id", options_label: "name" },
                { prop: 'type', name: 'ACTIVITY.type', sortable: false, hasFilter: true, filter: "select", options: 'types', options_id: "id", options_label: "name" }
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchActivities({id: this.recordId}));
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '', 
            action: null, //Null for select list
            type: null, //Null for select list
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}